/*
 * Copyright (c) 2026 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import { trackVercelEvent } from '@/lib/analytics/vercel'
import { captureGclid, isValidGclid } from '@/lib/attribution/gclid'

/**
 * Captures a GCLID from the URL on every navigation, and counts arrivals from a Google Ads click. Mounted once in the
 * shared layout, so landing pages without a form still record the click.
 */
export const GclidCapture = () => {
  const search = useSearchParams().toString()

  useEffect(() => {
    captureGclid(search)

    if (isValidGclid(new URLSearchParams(search).get('gclid'))) {
      trackVercelEvent('landed_with_gclid')
    }
  }, [search])

  return null
}
